import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function R() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('secR_q1'),
            desc: t.rich('secR_a1', {
                a1: (text: string) => (
                    <Link href={t('secR_a1_link1')} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secR_q2'),
            desc: t.rich('secR_a2', {
                a1: (text: string) => (
                    <Link
                        href={['nl']?.includes(locale) ? t('secR2_a1_link1') : `https://blog.ecoflow.com/${locale}/how-many-solar-panels-do-you-need-for-rv/`}
                        className="a-link"
                    >
                        {text}
                    </Link>
                ),
                a2: (text: string) => (
                    <Link href={['nl']?.includes(locale) ? t('secR2_a1_link2') : `https://${locale}.ecoflow.com/pages/solar-panels`} className="a-link">
                        {text}
                    </Link>
                ),
                l1: (text: string) => (
                    <Link href={t('secR_a2_link1')} className="a-link">
                        {text}
                    </Link>
                ),
                l2: (text: string) => (
                    <Link href={t('secR_a2_link2')} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secR_q3'),
            desc: t.rich('secR_a3', {
                a1: (text: string) => (
                    <Link href={t('secR_a3_link1')} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secR_q4'),
            desc: t.rich('secR_a4', {
                a1: (text: string) => (
                    <Link href={t('secR_a4_link1')} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secR_q5'),
            desc: t.rich('secR_a5', {
                a1: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/products/delta-pro-portable-power-station`} className="a-link">
                        {text}
                    </Link>
                ),
                a2: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/pages/off-grid-solar-system`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secR_q6'),
            desc: t.rich('secR_a6', {
                a1: (text: string) => (
                    <Link href={`https://blog.ecoflow.com/${locale}/how-to-prepare-for-full-time-rv-living/`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secR_q7'),
            desc: t('secR_a7'),
        },
    ];

    if (['uk', 'eu', 'it', 'es', 'kr', 'nl'].includes(locale)) {
        lists?.pop();
    }

    return (
        <div id="vanlife-roadtrips-R" className={`vanlife-roadtrips-R ${css['vanlife-roadtrips-R']}`}>
            <div className="ef-content">
                <div className="text-box">
                    <p className="title">{t('secR_title')}</p>
                </div>
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    defaultActiveKey={0}
                    expandIcon={({ isActive }: any) => {
                        return (
                            <svg
                                className={`collapse-icon ${isActive ? 'active' : ''}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                            >
                                <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        );
                    }}
                    expandIconPosition="right"
                >
                    {lists?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </div>
    );
}
